import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Image } from '@bottomless/common/components';
import { Link } from 'react-router-dom';
import { UsingContainer } from './UsingContainer';

export const SetupScale = ({ flow, timestamp }) => {
  const isNewWifi = useMemo(() => flow === 'new_wifi', [flow]);

  const heading = useMemo(() => (isNewWifi ? 'Sync to new Wi-Fi' : 'Set "zero level"'), [isNewWifi]);

  return (
    <Box secondary className="mb-4">
      <h2 className="text-center mb-4">{heading}</h2>
      <div className="text-center">
        <Image
          src="/connect-scale/scale-bottom.png"
          alt="Scale setup"
          width={300}
          height={198}
          useSrcset
          className="mb-4"
        />
      </div>
      {!isNewWifi && (
        <div className="mb-4 text-center">
          {
            'Press the "Setup" button on the bottom of your scale, then place it empty on a flat surface to set the "zero level".'
          }
        </div>
      )}
      {isNewWifi && (
        <div className="mb-4 text-center">Press the &quot;Setup&quot; button on the bottom of your scale.</div>
      )}
      <Link
        to={`/activate/step3?flow=${flow}&timestamp=${timestamp}`}
        title="Next"
        className="btn btn-lg btn-dark btn-block"
      >
        Next
      </Link>
      {!isNewWifi && <UsingContainer />}
    </Box>
  );
};

SetupScale.propTypes = {
  flow: PropTypes.string.isRequired,
  timestamp: PropTypes.string.isRequired,
};
